<template>
  <portlet
    :icon="'fad fa-edit'"
    :title="'Kandidaat plaatsen'"
    :footer="true"
  >
    <template slot="portletBody">
      <div class="row">
        <div class="form-group col-lg-4">
          <label for="candidatePlacement-customer">Bedrijf</label>
          <input
            readonly
            name="candidatePlacement-customer"
            id="candidatePlacement-customer"
            type="text"
            class="form-control"
            v-model="candidatePlacement.customer"
          />
        </div>
        <div class="form-group col-lg-4">
          <label for="candidatePlacement-vacancy">Vacature</label>
          <input
            readonly
            name="candidatePlacement-vacancy"
            id="candidatePlacement-vacancy"
            type="text"
            class="form-control"
            v-model="candidatePlacement.vacancy"
          />
        </div>
        <div class="form-group col-lg-4">
          <label for="candidatePlacement-candidate">Kandidaat</label>
          <v-select
            :options="getAvailableCandidatesPerCustomer(vacancy.customerId)"
            v-if="renderedComponent"
            :selectOnTab="true"
            :get-option-label="getCandidateLabel"
            v-model="candidatePlacement.candidate"
            v-validate="'required'"
            name="candidate"
            id="candidatePlacement-candidate"
            :class="{ 'is-invalid': errors.has('candidate')}"
          >
            <div slot="no-options">Alle kandidaten zijn geplaatst.</div>
          </v-select>
          <span v-if="errors.first('candidate')" class="small text-danger">Dit veld is verplicht</span>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-lg-4">
          <label for="candidatePlacement-startDate">Begin datum</label>
          <datepicker
            :language="nl"
            id="candidatePlacement-startDate"
            v-model="candidatePlacement.startDate"
            :fullMonthName="true"
            format="dd-MM-yyyy"
            input-class="form-control"
            :calendar-button="true"
            :calendar-button-icon="'far fa-calendar-alt'"
            :clear-button="true"
            :clear-button-icon="'far fa-times'"
            :class="{ 'is-invalid': errors.has('date') }"
          ></datepicker>
          <input
            v-model="candidatePlacement.startDate"
            v-show="false"
            v-validate="'required'"
            name="date"
          />
          <span v-if="errors.first('date')" class="small text-danger">Dit veld is verplicht</span>
        </div>
        <div class="form-group col-lg-4">
          <label for="candidatePlacement-hourlyWage">Uurloon</label>
          <input
            v-validate="'required'"
            name="vacancy-hourlyWage"
            id="candidatePlacement-hourlyWage"
            type="number"
            class="form-control"
            v-model="candidatePlacement.hourlyWage"
          />
          <span v-if="errors.first('vacancy-hourlyWage')" class="small text-danger">Dit veld mag alleen cijfers en komma's bevatten.</span>
        </div>
        <div class="form-group col-lg-4">
          <label>Pensioen</label>
          <v-select :options="getStandardFormChoices('retirements')"
                    v-model="candidatePlacement.retirement"
                    label="name"
                    :selectOnTab="true"
          />
        </div>
      </div>
      <div class="row">
        <div class="form-group col">
          <label for="customer-defaultInstructions">Welkomst e-mail</label>
          <tiptap-editor
            v-model="candidatePlacement.firstDayInstructions"
            :content="candidatePlacement.firstDayInstructions"/>
        </div>
      </div>
    </template>
    <div slot="portletFooter" class="col-12 text-right">
      <button @click="saveCandidatePlacement" type="submit" class="btn btn-primary">
        <i class="fal fa-save mr-2"></i> Opslaan
      </button>
    </div>
  </portlet>
</template>

<script>
  import {mapGetters} from "vuex";
  import {nl} from "vuejs-datepicker/dist/locale";

  export default {
    props: ["id", "vacancy"],
    data() {
      return {
        nl: nl,
        renderedComponent: true,
        candidatePlacementCopy: null,
        candidatePlacement: {
          customer: "",
          customerId: "",
          vacancy: "",
          candidate: "",
          startDate: "",
          endDate: "",
          hourlyWage: "",
          retirement: null,
          firstDayInstructions: ""
        },
      }
    },
    methods: {
      getCandidateLabel(option) {
        return `${option.firstName} ${option.lastName}`;
      },

      getCustomerName(id) {
        this.candidatePlacement.customer = this.getCustomer(id).name;
      },

      renderComponent() {
        this.renderedComponent = false;

        this.$nextTick(() => {
          this.renderedComponent = true;
        });
      },
      removeCandidateFromPool(customerId, candidateId) {
        const poolsOfCandidate = this.getPoolsOfCandidateId(candidateId);
        _.filter(poolsOfCandidate, {
          'customerId': customerId,
          'archived': false
        }).forEach(pool => {
          this.$store.dispatch('pools/patch', {
            id: pool.id,
            archived_at: new Date(),
            archived_by: this.$store.getters.getUserData,
            archived: true
          })
        });
      },
      saveCandidatePlacement() {
        this.$validator.validate().then(result => {
          if (result) {
            const userData = this.$store.getters.getUserData;
            let candidatePlacementData = {
              customerId: this.vacancy.customerId,
              vacancyId: this.vacancy.id,
              candidateId: this.candidatePlacement.candidate.id,
              startDate: moment(this.candidatePlacement.startDate).format("YYYY-MM-DD"),
              endDate: this.candidatePlacement.endDate,
              hourlyWage: this.candidatePlacement.hourlyWage,
              retirement: this.candidatePlacement.retirement,
              firstDayInstructions: this.candidatePlacement.firstDayInstructions,
              candidateIsHolidayWorker: _.includes(this.candidatePlacement.candidate.shifts, "Vakantiekracht"),
              department: userData.selectedDepartment,
              createdBy: userData,
            };
            this.$store.dispatch("placements/set", candidatePlacementData).then(() => {
              this.removeCandidateFromPool(candidatePlacementData.customerId, candidatePlacementData.candidateId)
              this.$toasted.global.successRequest({
                message: "Plaatsing aangemaakt"
              });

              this.$emit("unsavedChanges", false)

              this.$router.push("/vacancies")
              this.renderComponent();
            }).catch(() => {
              this.$toasted.global.failedRequest();
            });
          } else {
            this.$toasted.global.failedFormRequest();
          }
        });
      }
    },
    computed: {
      ...mapGetters("vacancies", [
        "getVacancies",
        "getVacanciesFromCustomer"
      ]),
      ...mapGetters("candidates", ["getAvailableCandidatesPerCustomer", "getStandardFormChoices"]),
      ...mapGetters("placementsHistory", ["getPlacementsHistoryArray"]),
      ...mapGetters("customers", ["getCustomer",]),
      ...mapGetters('pools', ['getPoolsOfCandidateId'])
    },
    watch: {
      candidatePlacement: {
        handler: function (val) {
          this.$emit("unsavedChanges", JSON.stringify(val) !== JSON.stringify(this.candidatePlacementCopy));
        },
        deep: true
      }
    },
    created() {
      this.candidatePlacement.vacancy = this.vacancy.name;
      this.candidatePlacement.customerId = this.vacancy.customerId;
      this.candidatePlacement.firstDayInstructions =  this.getCustomer(this.vacancy.customerId).defaultInstructions;
      this.getCustomerName(this.candidatePlacement.customerId);

      this.candidatePlacementCopy = JSON.parse(
        JSON.stringify(this.candidatePlacement)
      );
    }
  };
</script>